import { render, staticRenderFns } from "./WithdrawFeeSetting.vue?vue&type=template&id=c2fb255c&scoped=true"
import script from "./WithdrawFeeSetting.vue?vue&type=script&lang=js"
export * from "./WithdrawFeeSetting.vue?vue&type=script&lang=js"
import style0 from "./WithdrawFeeSetting.vue?vue&type=style&index=0&id=c2fb255c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fb255c",
  null
  
)

export default component.exports